import React from 'react';
import { BrowserRouter , Link } from 'react-router-dom';
import imag from '../../asserts/images/hawiya.jpg' ;
import './Actualites.css';
import Actualites from '../Actualites/Actualites';

function ActualitesComponent() {
  return (

    

    <div className='actualites'style={{marginTop:'60px'}}>
         <h5 className="container-fluid text-center" style={{color:'orange', fontSize:'16px',paddingTop:'20px'}}>RESTEZ INFORMÉS</h5>
         <div className="title" >
             <h3 style={{fontSize:'40px',textAlign:'center',marginBottom:'20px'}}>Actualités & événements</h3>
             <br/>
         </div>

       <div style={{ position:'relative',marginTop:'-80px'}}>  <Actualites /></div>
       <div className='divbtn'> 
          <Link to={{
                        pathname: '/ToutesActualités',
                        state: { information: imag }
                      }}>                  
              <button className='btnactualites'>Toutes les actualités {'>'}{'>'} </button>
            </Link> 

          
          </div>
        
          
            
          
         
         
    </div>
  )
}

export default ActualitesComponent


